/*eslint no-console: 0*/
import config from '../../lib/config'
import PageMixins from '../../components/_mixins/pages'
import ValidationMixins from '../../components/_mixins/validation'

import ForgetPassword from './forget-password'
import VerifyAccountError from '../../components/global/verify-account-error'

import {required, maxLength, email, minLength} from 'vuelidate/lib/validators'

import ProviderService from '../../services/provider'

const components = {
  ForgetPassword,
  VerifyAccountError
}

export default {
  name: 'page-raceway-login',
  settings: 'page.login',
  translations: 'page.login',
  props: {
    showPasswordReset: {
      type: Boolean,
      default: false
    },
    hideSignUp: {
      type: Boolean,
      default: false
    }
  },
  mixins: [PageMixins, ValidationMixins],
  components,
  data() {
    return {
      hideRegistrationBox: false,
      bannerImage: config.LOGIN_BOX_BG,
      loginError: '',
      isLoggingIn: false,
      isFormDisabled: false,
      tryingEmail: null,
      email: null,
      query: {},
      password: null,
      validations: {
        email: {
          name: 'email',
          validator: this.submittingInvalidRule,
          items: {
            required: {error: 'Email is required.'},
            email: {error: 'Email is not valid.'},
          },
        },
        password: {
          name: 'password',
          validator: this.submittingInvalidRule,
          items: {
            required: {error: 'Password can not be blank.',}
          },
        },
      },
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
    }
  },
  mounted() {

  },
  created() {
    // window.skipGlobalTimerMessage = true
    this.hideRegistrationBox = this.hideSignUp
    this.query = this.$route.query
    if (this.showPasswordReset) {
      this.showResetPassword(true)
    }
  },
  computed: {
    loginBannerStyle() {
      return { backgroundImage: `url('${this.bannerImage}')`}
    }
  },
  methods: {
    async loginNow() {
      this.$v.$touch()
      this.loginError = ''
      this.formSubmitting = true
      if (!this.isAnyInvalid) {
        this.isFormDisabled = true
        this.isLoggingIn = true
        const {email, password, query} = this
        this.tryingEmail = email
        try {
          const loginResult = await ProviderService.login({email, password, query})
          // console.log(loginResult);

          if (loginResult.success) {

            loginResult.email = email

            const rootLoginSuccess = await this.rootLogin(loginResult)

            if (rootLoginSuccess === true) {
              this.setCustomer(loginResult.customer)
              // console.log(this.loginRedirect)
              let redirect = this.loginRedirect
              if (!redirect) {
                redirect = 'page-profile'
              }
              this.setPostLoginPage(null)
              this.goto(redirect)

            } else {
              this.loginError = rootLoginSuccess.response.data.message
              this.isFormDisabled = false
            }

          } else {
            if (loginResult.verified === false) {
              this.showUserVerificationPrompt(true)
            } else {
              this.loginError = loginResult.error || 'Ops! unable to login! Please try again.'
            }
            this.isFormDisabled = false
          }

        } catch (e) {
          this.loginError = ProviderService.getFirstErrorMessage(e) || 'Ops! unable to login! Please try again.'
          this.isFormDisabled = false
        }

        this.isLoggingIn = false
      }
    },
    async rootLogin(firstLoginData) {
      try {
        this.saveToken({
          token: firstLoginData.access_token
        })
        await this.fetchUser()

      } catch (error) {
        // console.log([error, error.response.data.message]);
        return error
      }
      return true
    },

    forgetPassword() {
      this.tryingEmail = this.email || ''
      this.showResetPassword(true)
    }
  }
}
